var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGermany = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5207_30146)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.466797 10.1092C1.52649 12.9652 4.27557 15.0005 7.5003 15.0005C10.725 15.0005 13.4741 12.9652 14.5338 10.1092L7.5003 9.45703L0.466797 10.1092Z",
  fill: "#FFDA44"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5003 0C4.27557 0 1.52649 2.03531 0.466797 4.89132L7.5003 5.54347L14.5338 4.89129C13.4741 2.03531 10.725 0 7.5003 0Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.466494 4.89062C0.165029 5.70312 0 6.5819 0 7.49931C0 8.41671 0.165029 9.2955 0.466494 10.108H14.5335C14.835 9.2955 15 8.41671 15 7.49931C15 6.5819 14.835 5.70312 14.5335 4.89062H0.466494Z",
  fill: "#D80027"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5207_30146"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 15,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGermany);
export { ForwardRef as ReactComponent };